import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import SkelotonEffect from './SkelotonEffect';
import BookModal from './BookModal';
import Pagination from "react-js-pagination";
import InternalBanner from './InternalBanner';
import { getLibrary } from "../services/bookService";
import { ToastContainer, toast } from 'react-toastify';
import { shareBook } from "../utils/shareBook";
import { renderStars } from "../utils/renderStars";
import { openBook } from "../utils/openBook";
import { URL } from "../utils/constants";
import AOS from 'aos';
import 'aos/dist/aos.css';

const MyLibrary = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [selectedBook, setSelectedBook] = useState(null);
    const [libraryBooks, setLibraryBooks] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const limit = 24;
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const location = useLocation();


    const handleInstantRemove = (bookId) => {
        setLibraryBooks(prev =>
            prev.filter(book => book.id !== bookId)
        );
    };

    useEffect(() => {
        const fetchMyBooks = async () => {
            try {
                setIsLoading(true);
                setError(null);
                const response = await getLibrary({
                    page: page,
                    limit: limit,
                });

                if (!response?.success || !response?.data?.length) {
                    toast.success("No more books available.");
                    setLibraryBooks([]);
                } else {
                    setLibraryBooks(response.data);
                    setTotalItems(response.pagination?.total || 0);
                }
            } catch (error) {
                console.error("Error fetching my books:", error);
                setError("Failed to load books");
            } finally {
                setIsLoading(false);
            }
        };

        fetchMyBooks();
    }, [page]);


    const openModal = (book) => {
        setSelectedBook(book);
        setShowModal(true);
        document.body.classList.add("remove-scroll");
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedBook(null);
        document.body.classList.remove("remove-scroll");
    };

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
    }, []);

    const handleAuthorClick = (authorID) => {
        localStorage.setItem('authorId', authorID); // optional: store it
        navigate('/author-books', { state: { authorID } });
    };

    const handlePublisherClick = (publisherID) => {
        localStorage.setItem('authorId', publisherID); // optional: store it
        navigate('/publisher-books', { state: { publisherID } });
    };

    const handleBookID = (BookID) => {
        localStorage.setItem('bookId', BookID);
        navigate('/addReview', { state: { BookID } });
    };

    const goBack = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.history.length > 1) {
            navigate(-1); // Equivalent to window.history.back()
        } else {
            alert('No history available to go back.');
        }
    };

    useEffect(() => {
        document.body.classList.remove("remove-scroll");
    }, [location]);


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                theme="dark"
            />
            <InternalBanner title="My Library" />
            <BookModal
                showModal={showModal}
                closeModal={closeModal}
                selectedBook={selectedBook}
                handleShare={shareBook}
                renderStars={renderStars}
                handleBookID={handleBookID}
                handleAuthorClick={handleAuthorClick}
                handlePublisherClick={handlePublisherClick}
                handleActionClick={() => openBook(navigate, selectedBook)}
                handleInstantRemove={handleInstantRemove}
            />

            {error ? (
                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src={`${process.env.PUBLIC_URL}/assets/images/error.png`} alt="error" />

                    </div>
                </section>
            ) : isLoading ? (
                <SkelotonEffect />
            ) : (
                <div className='container-fluid'>
                    <div className='row bg-body-color'>
                        {libraryBooks?.length > 0 ? (
                            <section id="nutrition" className='books py-4'>
                                <div className='container space-container'>
                                    <div className='col-md-12'>
                                        <button className="btn-6 view-all-btnn mb-4" onClick={goBack}><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6'>
                                            {libraryBooks.map(datav => (
                                                <div className='col mb-4' key={datav.id}>
                                                    <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                        <div className='product-media'>
                                                            <div className="product-image">
                                                                <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                    <div className="df-book-wrapper">
                                                                        <div className="df-book-page1">
                                                                        </div>
                                                                        <div className="df-book-page2">
                                                                        </div>
                                                                        <div className="df-book-cover df-icon-play-popup">
                                                                            <img
                                                                                src={ `${URL}/${datav.book_cover_img}`}
                                                                                className='w-100'
                                                                                alt="Book Cover with-placeholder"
                                                                                onLoad={(e) => {
                                                                                    e.currentTarget.classList.remove('with-placeholder');
                                                                                }}
                                                                                onError={(e) => {
                                                                                    if (!e.currentTarget.dataset.fallback) {
                                                                                        e.currentTarget.dataset.fallback = "true";
                                                                                        e.currentTarget.src = "/assets/images/elements/book_cover.png";
                                                                                    }
                                                                                }}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='book-content'>
                                                        <h6 className="book-name">
                                                            {datav.book_title}
                                                        </h6>
                                                        <p>
                                                            <span>Author :</span> {datav.author_name}
                                                        </p>
                                                        
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className='col-md-12 text-end mt-4'>
                                        {totalItems > limit && (
                                            <div className="d-flex justify-content-end mt-4">
                                                <Pagination
                                                    activePage={page}
                                                    itemsCountPerPage={limit}
                                                    totalItemsCount={totalItems}
                                                    pageRangeDisplayed={5}
                                                    onChange={setPage}
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    prevPageText="Previous"
                                                    nextPageText="Next"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </section>
                        ) : (

                            <div className="container py-5 text-center">
                                <div className='row justify-content-center'>
                                    <div className='col-md-6 no_more_data'>
                                        <h3>No Books Available</h3>
                                        <p>Your library is currently empty.</p>
                                    </div>
                                </div>

                            </div>)}
                    </div>
                </div>
            )}
        </>
    );
};

export default MyLibrary;




